"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const mobx_react_1 = require("mobx-react");
const ProductBox_1 = require("./Elements/ProductBox");
const Store_1 = require("./Store");
const ContentArea_1 = require("./Elements/ContentArea");
const Hero_1 = require("./Elements/Hero");
let SubcategoryDisplay = class SubcategoryDisplay extends React.Component {
    componentDidMount() {
        Store_1.default.siteName = "Hartwall";
        document.title = Store_1.default.currentPageName + " | " + Store_1.default.siteName;
        //store.updateNavigationColor(store.containerId);
    }
    render() {
        const heading = Store_1.default.SelectedSubcategory.heading || Store_1.default.SelectedSubcategory.name;
        return (React.createElement(React.Fragment, null,
            React.createElement(Hero_1.default, { backgroundImageUrl: Store_1.default.SelectedSubcategory.backgroundImageUrl, heading: heading, ingressText: Store_1.default.SelectedSubcategory.ingress, dimFilter: Store_1.default.SelectedSubcategory.dimFilter }),
            React.createElement(ContentArea_1.default, { content: Store_1.default.SelectedSubcategory.id, language: Store_1.default.currentLanguage, area: "TopContentArea" }),
            React.createElement("div", { className: "o-container" },
                React.createElement("h3", { className: "s-h3-s u-mt-0 u-mb-1 _sm-u-mb-2 u-pl-1" }, Store_1.default.SelectedSubcategory.productsText)),
            React.createElement("div", { className: "o-container u-mb-4" },
                React.createElement("div", { className: "o-product-listing-wrapper" },
                    Store_1.default.loading &&
                        React.createElement("div", { className: "ui active inverted dimmer" },
                            React.createElement("div", { className: "ui text loader" }, Store_1.default.Translations.loadingText)),
                    React.createElement("div", { className: "row" }, Store_1.default.Products && Store_1.default.Products.map(function (product) {
                        return (React.createElement(ProductBox_1.default, { key: product.id, product: product }));
                    })))),
            React.createElement(ContentArea_1.default, { content: Store_1.default.SelectedSubcategory.id, language: Store_1.default.currentLanguage, area: "BottomContentArea" })));
    }
};
SubcategoryDisplay = __decorate([
    mobx_react_1.observer
], SubcategoryDisplay);
exports.default = SubcategoryDisplay;
